const prefix = '@gifts';

export const CHANGE_APP_MODAL = `${prefix}/CHANGE_APP_MODAL`;
export const CHANGE_VPN_MODAL = `${prefix}/CHANGE_VPN_MODAL`;
